import React, { useMemo } from 'react';

import { useOrdersQuery } from 'api/queries/orderQueries';
import Button from 'components/basic/Button/Button';
import { useIsMobile } from 'hooks/useIsMobile';
import { redirectTo } from 'lib/redirect';

import ActiveOrdersTable from '../ActiveOrdersTable';
import { useCancelAllOrders } from '../cancelAllOrders';

export default function ActiveOrdersMultiMarketTable({
  marketFilter,
}: {
  marketFilter?: string;
}) {
  const isMobile = useIsMobile();
  const { data: activeOrders, isLoading } = useOrdersQuery();
  const { cancelAllModalPlaceholder, showCancelAllConfirmation } =
    useCancelAllOrders(marketFilter);

  const activeOrdersFiltered = useMemo(() => {
    return (activeOrders || []).filter(
      order => !marketFilter || order.market === marketFilter
    );
  }, [activeOrders, marketFilter]);

  return (
    <>
      {cancelAllModalPlaceholder}
      <ActiveOrdersTable
        isLoading={isLoading}
        orders={activeOrdersFiltered}
        onSelectOrder={orderId => redirectTo(`/wallet/open-orders/${orderId}`)}
        onCancelAll={showCancelAllConfirmation}
      />
      {isMobile && activeOrders && activeOrders?.length > 1 && (
        <Button onClick={showCancelAllConfirmation} color="red" bordered>
          Cancel All {marketFilter ? `${marketFilter} Orders` : ''}
        </Button>
      )}
    </>
  );
}
